// @ts-nocheck
import { useEffect, useState } from 'react';
import { getFirstName } from 'utils/formatter';
import { inviteMessageWithUser, inviteMessageWithoutUser } from '../utils/advisorTextOptions';

const useInviteText = (userExists, defaultMessage, userName, advisorName) => {
    const [message, setMessage] = useState(defaultMessage ?? '');

    useEffect(() => {
        if (userExists) {
            setMessage(inviteMessageWithUser(userName, getFirstName(advisorName)));
        } else {
            setMessage(inviteMessageWithoutUser(userName, getFirstName(advisorName)));
        }
    }, [userExists, userName, advisorName]);

    return [message, setMessage];
};

export default useInviteText;
